import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import NewTr from "../../common/table/newTr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import * as am4core from "@amcharts/amcharts4/core";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

import FormatUtils from "../../common/formatUtils/FormatUtils";
import {
    getListaGraficoGeracaoQuantidadeAnual,
    getGeracaoCadastro,
    getListaGraficoGeracaoSaldo,
    getListaGraficoGeracaoAvaliacaoProducao,
    getListaGraficoGeracaoComparativoConsumo,
    getListaGraficoGeracaoEconomia,
    getListaGraficoGeracaoEconomiaPonta,
    getListaGraficoGeracaoConsumoInstantaneo,
    getListaGraficoComparativoComSemSolarMensal,
    getListaGraficoComparativoComSemSolarPeriodo,
    getDemanda,
    getListaIndiceAntesDepois,
    setFiltro,
} from "../analiseActions";
import { gerarRelatorio } from "../../fatura/faturaActions.js";

import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar.js";
import { montarGraficoLineMensal } from "../../common/graficos/montarGraficoLineMensal.js";
import { montarGraficoClusteredColumnAnual } from "../../common/graficos/montarGraficoClusteredColumnAnual.js";
import { montarGraficoClusteredColumnMensal } from "../../common/graficos/montarGraficoClusteredColumnMensal.js";
import { montarGraficoClusteredColumnLineMensal } from "../../common/graficos/montarGraficoClusteredColumnLineMensal.js";
import { montarGraficoGroupStackedColumn } from "../../common/graficos/montarGraficoGroupStackedColumn.js";

import iconeIgualAzul from "../../assets/images/equal-blue.png";
import iconeMaiorVerde from "../../assets/images/up-arrow-green.png";
import iconeMenorVermelho from "../../assets/images/down-arrow-red.png";
import AlertIcon from "../../common/alertIcon/alertIcon.jsx";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";
import Row from "../../common/layout/row.jsx";
import Grid from "../../common/layout/grid.jsx";
import Button from "../../common/button/button.jsx";
import { setInfo, setWarning } from "../../common/toast/toast.jsx";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import { Loading } from "../../common/loading/loading.jsx";
import Select from "../../common/form/select.jsx";

function AnaliseMicroMiniGeracaoComponent(props) {
    if (!props.visible) return null;

    const {
        filtro,
        state,
        setAguardando,
        contratoDemanda,
        buscarPropriedadeUcFiltrada,
        listaGeracaoContrato,
        listaIndiceAntesDepois,
        listaUnidadeConsumidora,
        listaGraficoGeracaoSaldo,
        listaGraficoGeracaoEconomia,
        listaGraficoGeracaoEconomiaPonta,
        listaGraficoGeracaoQuantidadeAnual,
        listaGraficoGeracaoComparativoConsumo,
        listaGraficoGeracaoConsumoInstantaneo,
        listaGraficoGeracaoAvaliacaoProducaoAnual,
        listaGraficoComparativoComSemSolarMensal,
        listaGraficoComparativoComSemSolarPeriodo,
        setFiltro,
        getDemanda,
        gerarRelatorio,
        getGeracaoCadastro,
        getListaIndiceAntesDepois,
        getListaGraficoGeracaoSaldo,
        getListaGraficoGeracaoEconomia,
        getListaGraficoGeracaoEconomiaPonta,
        getListaGraficoGeracaoQuantidadeAnual,
        getListaGraficoGeracaoAvaliacaoProducao,
        getListaGraficoGeracaoComparativoConsumo,
        getListaGraficoGeracaoConsumoInstantaneo,
        getListaGraficoComparativoComSemSolarMensal,
        getListaGraficoComparativoComSemSolarPeriodo,
    } = props;

    const umaUnicaFiltrada = filtro.unidades_consumidoras.length === 1;
    const ucFiltro = listaUnidadeConsumidora.find((uc) => filtro.unidades_consumidoras[0] && uc.id == filtro.unidades_consumidoras[0].value) || {};
    const ucFiltradaComRemotas = listaUnidadeConsumidora.filter((uc) => umaUnicaFiltrada && (uc.id == ucFiltro.id || uc.id_unidade_geradora == ucFiltro.id));

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [graficoGeracaoQuantidadeAnual, setGraficoGeracaoQuantidadeAnual] = useState(null);
    const [graficoGeracaoQuantidadeMensal, setGraficoGeracaoQuantidadeMensal] = useState(null);
    const [graficoGeracaoSaldo, setGraficoGeracaoSaldo] = useState(null);
    const [graficoGeracaoAvaliacaoProducaoAnual, setGraficoGeracaoAvaliacaoProducaoAnual] = useState(null);
    const [graficoGeracaoAvaliacaoProducaoMensal, setGraficoGeracaoAvaliacaoProducaoMensal] = useState(null);
    const [graficoGeracaoComparativoConsumo, setGraficoGeracaoComparativoConsumo] = useState(null);
    const [graficoGeracaoEconomia, setGraficoGeracaoEconomia] = useState(null);
    const [graficoGeracaoRetornoFinanceiro, setGraficoGeracaoRetornoFinanceiro] = useState(null);
    const [graficoGeracaoEconomiaTotal, setGraficoGeracaoEconomiaTotal] = useState(null);
    const [graficoGeracaoAnaliseRetornoFinanceiroAnual, setGraficoGeracaoAnaliseRetornoFinanceiroAnual] = useState(null);
    const [graficoGeracaoEconomiaPonta, setGraficoGeracaoEconomiaPonta] = useState(null);
    const [graficoGeracaoConsumoInstantaneo, setGraficoGeracaoConsumoInstantaneo] = useState(null);
    const [graficoComparativoComSemSolarMensal, setGraficoComparativoComSemSolarMensal] = useState(null);
    const [graficoComparativoComSemSolarEnergiaPeriodo, setGraficoComparativoComSemSolarEnergiaPeriodo] = useState(null);
    const [graficoComparativoComSemSolarValorPeriodo, setGraficoComparativoComSemSolarValorPeriodo] = useState(null);
    const [modoGraficoComparativoComSemSolar, setModoGraficoComparativoComSemSolar] = useState("kWh");
    const [filtroUCs, setFiltroUCs] = useState([]);
    const [filtroUcsInicializado, setFiltroUcsInicializado] = useState(false);
    const [exibirUCs, setExibirUCs] = useState(false);

    useEffect(() => {
        const filtroAtualizado = ucFiltradaComRemotas.map((uc) => ({ label: uc.valor, value: uc.id }));
        if (umaUnicaFiltrada && ucFiltradaComRemotas.length > 1 && JSON.stringify(filtroAtualizado) !== JSON.stringify(filtroUCs) && !filtroUcsInicializado) {
            setFiltroUCs(filtroAtualizado);
            setFiltroUcsInicializado(true);
        }
    }, [ucFiltradaComRemotas]);

    useEffect(() => {
        if (!filtroUcsInicializado) return;
        atualizarListaGraficoGeracaoEconomia();
    }, [filtroUCs, filtroUcsInicializado]);

    useEffect(() => {
        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;

            await Promise.all([
                getListaIndiceAntesDepois(),
                getGeracaoCadastro(),
                getListaGraficoGeracaoQuantidadeAnual(),
                getListaGraficoGeracaoSaldo(),
                getListaGraficoGeracaoAvaliacaoProducao(),
                getListaGraficoGeracaoComparativoConsumo(),
                getListaGraficoGeracaoEconomia(),
                getListaGraficoGeracaoEconomiaPonta(),
                getListaGraficoGeracaoConsumoInstantaneo(),
                getListaGraficoComparativoComSemSolarMensal(),
                getListaGraficoComparativoComSemSolarPeriodo(),
                getDemanda(),
            ]);

            setAguardando(false);
        };

        setFiltroUcsInicializado(false);
        setFiltroUCs([]);
        setExibirUCs(false);
        buscarDados();
        if (!state.aguardando) {
            atualizarTodosGraficos();
        }
    }, [state.aguardando]);

    useEffect(() => {
        atualizarListaGraficoComparativoComSemSolarMensal();
    }, [modoGraficoComparativoComSemSolar, JSON.stringify(listaGraficoComparativoComSemSolarMensal)]);

    useEffect(() => {
        atualizarListaGraficosComparativosComSemSolarPeriodo();
    }, [modoGraficoComparativoComSemSolar, JSON.stringify(listaGraficoComparativoComSemSolarPeriodo)]);

    useEffect(() => {
        getListaGraficoComparativoComSemSolarMensal();
    }, [filtro.ano_comparativo_com_sem_solar]);

    useEffect(() => {
        getListaGraficoComparativoComSemSolarPeriodo();
    }, [filtro.competencia_inicial_geracao_comparativo_com_sem_solar, filtro.competencia_final_geracao_comparativo_com_sem_solar]);

    function atualizarTodosGraficos() {
        atualizarListaGraficoGeracaoQuantidadeAnual();
        atualizarListaGraficoGeracaoSaldo();
        atualizarListaGraficoGeracaoAvaliacaoProducao();
        atualizarListaGraficoGeracaoComparativoConsumo();
        atualizarListaGraficoGeracaoEconomia();
        atualizarListaGraficoGeracaoEconomiaPonta();
        atualizarListaGraficoGeracaoConsumoInstantaneo();
        atualizarListaGraficoComparativoComSemSolarMensal();
        atualizarListaGraficosComparativosComSemSolarPeriodo();
    }

    function desmontarTodosGraficos() {
        if (graficoGeracaoQuantidadeAnual) graficoGeracaoQuantidadeAnual.dispose();
        if (graficoGeracaoQuantidadeMensal) graficoGeracaoQuantidadeMensal.dispose();
        if (graficoGeracaoSaldo) graficoGeracaoSaldo.dispose();
        if (graficoGeracaoAvaliacaoProducaoAnual) graficoGeracaoAvaliacaoProducaoAnual.dispose();
        if (graficoGeracaoComparativoConsumo) graficoGeracaoComparativoConsumo.dispose();
        if (graficoGeracaoEconomia) graficoGeracaoEconomia.dispose();
        if (graficoGeracaoRetornoFinanceiro) graficoGeracaoRetornoFinanceiro.dispose();
        if (graficoGeracaoEconomiaTotal) graficoGeracaoEconomiaTotal.dispose();
        if (graficoGeracaoAnaliseRetornoFinanceiroAnual) graficoGeracaoAnaliseRetornoFinanceiroAnual.dispose();
        if (graficoGeracaoEconomiaPonta) graficoGeracaoEconomiaPonta.dispose();
        if (graficoGeracaoConsumoInstantaneo) graficoGeracaoConsumoInstantaneo.dispose();
        if (graficoComparativoComSemSolarMensal) graficoComparativoComSemSolarMensal.dispose();
        if (graficoComparativoComSemSolarEnergiaPeriodo) graficoComparativoComSemSolarEnergiaPeriodo.dispose();
        if (graficoComparativoComSemSolarValorPeriodo) graficoComparativoComSemSolarValorPeriodo.dispose();
    }

    function atualizarListaGraficoGeracaoQuantidadeAnual() {
        const graficoGeracaoQuantidadeAnualAtualizado = montarGraficoClusteredColumnAnual({
            state,
            component: graficoGeracaoQuantidadeAnual,
            nome: "graficoGeracaoQuantidadeAnual",
            dados: listaGraficoGeracaoQuantidadeAnual,
            titulo: "Comportamento de Energia Excedente Anual (kWh)",
            prefixo: "",
            sufixo: "kWh",
        });
        setGraficoGeracaoQuantidadeAnual(graficoGeracaoQuantidadeAnualAtualizado);

        const graficoGeracaoQuantidadeMensalAtualizado = montarGraficoLineMensal({
            state,
            component: graficoGeracaoQuantidadeMensal,
            nome: "graficoGeracaoQuantidadeMensal",
            dados: listaGraficoGeracaoQuantidadeAnual,
            titulo: "Comportamento de Energia Excedente Mensal (kWh)",
            prefixo: "",
            sufixo: "kWh",
            nomeCampo: "valor",
        });
        setGraficoGeracaoQuantidadeMensal(graficoGeracaoQuantidadeMensalAtualizado);
    }

    function atualizarListaGraficoGeracaoSaldo() {
        const graficoGeracaoSaldoAtualizado = montarGraficoClusteredColumnMensal({
            state: state,
            component: graficoGeracaoSaldo,
            nome: "graficoGeracaoSaldo",
            dados: listaGraficoGeracaoSaldo,
            titulo: "Saldo de Geração (kWh)",
            prefixo: "",
            sufixo: "kWh",
        });
        setGraficoGeracaoSaldo(graficoGeracaoSaldoAtualizado);
    }

    function atualizarListaGraficoGeracaoAvaliacaoProducao() {
        const graficoGeracaoAvaliacaoProducaoAnualAtualizado = montarGraficoClusteredColumnAnual({
            state,
            component: graficoGeracaoAvaliacaoProducaoAnual,
            nome: "graficoGeracaoAvaliacaoProducaoAnual",
            dados: listaGraficoGeracaoAvaliacaoProducaoAnual.map((item) => ({
                ...item,
                anos: item.anos.filter((itemAno) => !itemAno.ano.includes("indice")),
            })),
            titulo: "Avaliação da Produção Total (kWh)",
            prefixo: "",
            sufixo: "kWh",
        });

        setGraficoGeracaoAvaliacaoProducaoAnual(graficoGeracaoAvaliacaoProducaoAnualAtualizado);

        const graficoGeracaoAvaliacaoProducaoMensalAtualizado = montarGraficoClusteredColumnLineMensal(
            state,
            graficoGeracaoAvaliacaoProducaoMensal,
            "graficoGeracaoAvaliacaoProducaoMensal",
            listaGraficoGeracaoAvaliacaoProducaoAnual.map((item) => ({
                ...item,
                anos: item.anos.filter((itemAno) => !itemAno.ano.includes("indice")),
            })),
            "",
            "",
            "kWh"
        );
        setGraficoGeracaoAvaliacaoProducaoMensal(graficoGeracaoAvaliacaoProducaoMensalAtualizado);
    }

    function atualizarListaGraficoGeracaoComparativoConsumo() {
        const graficoGeracaoComparativoConsumoAtualizado = montarGraficoClusteredColumnMensal({
            state: state,
            component: graficoGeracaoComparativoConsumo,
            nome: "graficoGeracaoComparativoConsumo",
            dados: listaGraficoGeracaoComparativoConsumo.map((item) => ({
                mes: item.mes,
                anos: item.tipos.map((tipo) => ({
                    ano: tipo.tipo,
                    valor: tipo.tipo === "Antes" ? (item.tipos[1] && item.tipos[1].valor > 0 ? tipo.valor : 0) : tipo.valor,
                })),
            })),
            titulo: "",
            prefixo: "kWh",
            sufixo: "",
        });
        setGraficoGeracaoComparativoConsumo(graficoGeracaoComparativoConsumoAtualizado);
    }

    function atualizarListaGraficoGeracaoEconomia() {
        //ECONOMIA  MENSAL E ANUAL -------------------------------------------------------------------------------------------------------------------------------------------------

        //monta uma lista com cada ano, e as UCs com valor no respectivo ao, para exibir no tooltip o valor de cada uc
        //mas isso só é exibido assim se é uma geradora com remotas, se for uma unica UC não mostra
        let quantidadeUCs = 0;
        listaGraficoGeracaoEconomia.forEach((itemMes) => itemMes.anos.forEach((itemAno) => (quantidadeUCs = Math.max(quantidadeUCs, (itemAno.unidades || []).length))));

        const unidadesPorAno = [];
        listaGraficoGeracaoEconomia.forEach((item) => {
            //faz copia profunda pra poder editar
            const itemMes = JSON.parse(JSON.stringify(item));

            itemMes.anos.forEach((itemAno) => {
                //só exibe nome das UCs ao passar o mouse e valida filtro secundário de UCs se a geradora filtrada no filtro principal, com suas respectivas ucs, for qtd > 1;

                const anoNaLista = unidadesPorAno.find((el) => el.ano == itemAno.ano);

                //atualiza o valor do ano com base nas UCs selecionadas, antes de incluir ou incrementar o total do ano
                const unidadesParaIncluir = (itemAno.unidades || []).filter((nova) => {
                    //se tem 2 uc ou mais no filtro interno de ucs ligadas a geradora, faz o detalhamento por uc, senão só acumula o total de cada ano
                    if (!umaUnicaFiltrada || quantidadeUCs <= 1) return true;

                    if (filtroUCs.find((el) => el.value == nova.id_unidade_consumidora)) {
                        return true;
                    } else {
                        //se não ta na lista filtrada desconsidera, e desconta do total
                        itemAno.valor -= nova.valor;
                        return false;
                    }
                });

                if (anoNaLista) {
                    anoNaLista.valor += itemAno.valor;

                    unidadesParaIncluir.forEach((nova) => {
                        const ucNaLista = anoNaLista.unidades.find((el) => el.nome_unidade_consumidora === nova.nome_unidade_consumidora);
                        if (ucNaLista) {
                            ucNaLista.competencia += ", " + nova.competencia;
                            ucNaLista.valor += nova.valor;
                        } else {
                            anoNaLista.unidades.push({
                                nome_unidade_consumidora: nova.nome_unidade_consumidora,
                                competencia: nova.competencia,
                                valor: nova.valor,
                            });
                        }
                    });
                } else {
                    unidadesPorAno.push({
                        ano: itemAno.ano,
                        valor: itemAno.valor,
                        unidades: unidadesParaIncluir.map((nova) => ({
                            nome_unidade_consumidora: nova.nome_unidade_consumidora,
                            competencia: nova.competencia,
                            valor: nova.valor,
                        })),
                    });
                }
            });
        });

        //adiciona tooltip para o gráfico de economia anual
        const unidadesPorAnoComTooltip = unidadesPorAno.map((item) => ({
            ...item,
            tooltip: item.unidades.reduce((acc, uc, i) => {
                const listaCompetencias = uc.competencia.split(", ");
                return (acc += `${i > 0 ? "\n\u200B\n" : ""}UC: [bold]${uc.nome_unidade_consumidora}[/]\n${listaCompetencias.length > 1 ? "Competências" : "Competência"}: [bold]${
                    listaCompetencias.length > 1 ? `${listaCompetencias[0]} à ${listaCompetencias[listaCompetencias.length - 1]}` : uc.competencia
                }[/]\nValor: [bold]R$ ${adicionarPontosMilhar(uc.valor)}[/]`);
            }, ""),
        }));

        const graficoGeracaoEconomiaTotalAtualizado = montarGraficoClusteredColumnAnual({
            state,
            component: graficoGeracaoEconomiaTotal,
            nome: "graficoGeracaoEconomiaTotal",
            dados: [{ anos: unidadesPorAnoComTooltip }],
            titulo: "",
            prefixo: "R$",
            sufixo: "",
            negativo: false,
            ordenar: true,
            wrap: true,
            labelPersonalizado: umaUnicaFiltrada && quantidadeUCs > 1, // quando tem mais de uma mostra o tooltip personalizado com as UCs
        });
        setGraficoGeracaoEconomiaTotal(graficoGeracaoEconomiaTotalAtualizado);

        // usa quantidadeUCs para decidir como exibe o tooltip no grafico de economia anual e mensal
        const listaEconomiaMensalMapeada =
            umaUnicaFiltrada && quantidadeUCs > 1
                ? listaGraficoGeracaoEconomia.map((item) => {
                      //faz copia profunda pra poder editar
                      const itemMes = JSON.parse(JSON.stringify(item));
                      return {
                          ...itemMes,
                          anos: itemMes.anos.map((itemAno) => {
                              //atualiza o valor do ano com base nas UCs selecionadas, antes de incluir ou incrementar o total do ano
                              const unidadesParaIncluir = (itemAno.unidades || []).filter((nova) => {
                                  if (filtroUCs.find((el) => el.value == nova.id_unidade_consumidora)) {
                                      return true;
                                  } else {
                                      //se não ta na lista filtrada desconsidera, e desconta do total
                                      itemAno.valor -= nova.valor;
                                      return false;
                                  }
                              });

                              const { total, ucs } = unidadesParaIncluir.reduce(
                                  (acc, uc, i) => {
                                      //acumula o total do mes, somando o valor de cada uc
                                      acc.total += uc.valor;
                                      acc.ucs += i > 0 ? "\n\u200B\n" : "";

                                      acc.ucs += `UC: [bold]${uc.nome_unidade_consumidora}[/]]\nValor: [bold]R$ ${adicionarPontosMilhar(uc.valor)}[/]`;

                                      return acc;
                                  },
                                  { total: 0, ucs: "" }
                              );

                              const tooltip = `${ucs}\n\u200B\nValor Total: [bold]R$ ${adicionarPontosMilhar(total)}[/]`;
                              return { ...itemAno, tooltip };
                          }),
                      };
                  })
                : listaGraficoGeracaoEconomia;

        const graficoGeracaoEconomiaAtualizado = montarGraficoClusteredColumnMensal({
            state: state,
            component: graficoGeracaoEconomia,
            nome: "graficoGeracaoEconomia",
            dados: listaEconomiaMensalMapeada,
            titulo: "",
            prefixo: "R$",
            sufixo: "",
            labelPersonalizado: umaUnicaFiltrada && quantidadeUCs > 1, // quando tem mais de uma mostra o tooltip personalizado com as UCs,
        });
        setGraficoGeracaoEconomia(graficoGeracaoEconomiaAtualizado);

        //RETORNO FINANCEIRO MENSAL E ANUAL -------------------------------------------------------------------------------------------------------------------------------------------------

        const graficoGeracaoRetornoFinanceiroAtualizado = montarGraficoClusteredColumnMensal({
            state: state,
            component: graficoGeracaoRetornoFinanceiro,
            nome: "graficoGeracaoRetornoFinanceiro",
            dados: listaGraficoGeracaoEconomia.map((item) => ({
                mes: item.mes,
                anos: item.anos.map((tipo) => {
                    const investimentoAno = parseFloat((listaGeracaoContrato.find((geracao) => geracao.ano == tipo.ano) || {}).valor_investido) || 0;
                    return {
                        ano: tipo.ano,
                        valor: tipo.valor > 0 && investimentoAno > 0 ? (parseFloat(tipo.valor) * 100) / investimentoAno : 0,
                    };
                }),
            })),
            titulo: "",
            prefixo: "",
            sufixo: "%",
        });

        setGraficoGeracaoRetornoFinanceiro(graficoGeracaoRetornoFinanceiroAtualizado);

        //cria uma lista com o retorno financeiro, o valor inverstido no ano e o ano em si
        // [{
        //     agrupador: "Retorno"
        //     ano: 2022
        //     valor: 96692.82767
        //     valorInvestidoAno: 1418658
        // }]

        let listaEconomiaAnual = [];

        listaGraficoGeracaoEconomia.forEach((item) => {
            // console.log(item);
            item.anos.forEach((ano) => {
                const anoJaEstaNaLista = listaEconomiaAnual.find((retorno) => retorno.ano == ano.ano);
                if (anoJaEstaNaLista) {
                    anoJaEstaNaLista.valor += parseFloat(ano.valor);
                } else {
                    const geracao = listaGeracaoContrato.find((geracao) => geracao.ano == ano.ano) || {};
                    const competencia = geracao.competencia_inicio
                        ? String(geracao.competencia_inicio).substring(4, 6) + "/" + String(geracao.competencia_inicio).substring(0, 4)
                        : "";
                    const competenciaAmpliacao = geracao.competencia_ampliacao
                        ? String(geracao.competencia_ampliacao).substring(4, 6) + "/" + String(geracao.competencia_ampliacao).substring(0, 4)
                        : "";
                    const valorAmpliacao = parseFloat(geracao.valor_ampliacao) || 0;
                    const investimento = parseFloat(geracao.valor_investido) || 0;

                    listaEconomiaAnual.push({
                        agrupador: "Retorno",
                        ano: ano.ano,
                        valor: parseFloat(ano.valor),
                        valorInvestidoAno: investimento,
                        competencia,
                        competenciaAmpliacao,
                        valorAmpliacao,
                        anoInicioGeracao: listaGeracaoContrato[0] && listaGeracaoContrato[0].ano,
                    });
                }
            });
        });

        let economiaTotal = 0;
        const listaRetornoFinanceiroAnual = [];

        listaEconomiaAnual
            .sort((a, b) => a.ano - b.ano)
            .forEach((retorno, i) => {
                economiaTotal += retorno.valor;
                if ((retorno.anoInicioGeracao < retorno.ano && i == 0) || retorno.ano == retorno.anoInicioGeracao) {
                    const anoString = `Valor Investido Inicial ${retorno.competencia} = [bold]R$ ${adicionarPontosMilhar(retorno.valorInvestidoAno)}[/]\nValor Economizado em ${
                        retorno.ano
                    } = [bold]R$${adicionarPontosMilhar(retorno.valor)}[/]\nValor Resultante em ${retorno.ano} = [bold]${
                        economiaTotal - retorno.valorInvestidoAno < 0 ? " - " : ""
                    } R$${adicionarPontosMilhar(economiaTotal - retorno.valorInvestidoAno).replace("-", "")}[/]\n(Desc. Economias Iniciais)`;

                    listaRetornoFinanceiroAnual.push({
                        ...retorno,
                        ano: anoString,
                        tooltip: anoString,
                        valor: economiaTotal - retorno.valorInvestidoAno, // valorInvestidoAno já tem acumulada as ampliações
                    });
                } else {
                    const textoAmpliacao = retorno.competenciaAmpliacao
                        ? `\nAmpliação (invest. R$ ${adicionarPontosMilhar(retorno.valorAmpliacao)} em ${
                              retorno.competenciaAmpliacao
                          })\n(Acresc. Novo Invest. e Desc. Economias do Ano)`
                        : "";
                    const textoAno = `Valor Resultante em ${retorno.ano} = [bold]${adicionarPontosMilhar(economiaTotal - retorno.valorInvestidoAno)}[/]`;
                    const tooltipTexto = `Valor Economizado em ${retorno.ano}: [bold]${adicionarPontosMilhar(retorno.valor)}[/]\n${textoAno}${textoAmpliacao}`;

                    listaRetornoFinanceiroAnual.push({
                        ...retorno,
                        ano: `${retorno.ano}${textoAmpliacao}`,
                        tooltip: tooltipTexto,
                        valor: economiaTotal - retorno.valorInvestidoAno, // valorInvestidoAno já tem acumulada as ampliações
                    });
                }
            });
        const graficoGeracaoAnaliseRetornoFinanceiroAnualAtualizado = montarGraficoClusteredColumnAnual({
            state,
            component: graficoGeracaoAnaliseRetornoFinanceiroAnual,
            nome: "graficoGeracaoAnaliseRetornoFinanceiroAnual",
            dados: [{ anos: [...listaRetornoFinanceiroAnual] }],
            titulo: "",
            prefixo: "R$",
            sufixo: "",
            negativo: true,
            ordenar: false,
            wrap: false,
            labelPersonalizado: true,
        });
        setGraficoGeracaoAnaliseRetornoFinanceiroAnual(graficoGeracaoAnaliseRetornoFinanceiroAnualAtualizado);
    }

    function atualizarListaGraficoGeracaoEconomiaPonta() {
        if (!document.getElementById("graficoGeracaoEconomiaPonta")) return;
        const graficoGeracaoEconomiaPontaAtualizado = montarGraficoClusteredColumnMensal({
            state: state,
            component: graficoGeracaoEconomiaPonta,
            nome: "graficoGeracaoEconomiaPonta",
            dados: listaGraficoGeracaoEconomiaPonta,
            titulo: "",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoGeracaoEconomiaPonta(graficoGeracaoEconomiaPontaAtualizado);
    }

    function atualizarListaGraficoGeracaoConsumoInstantaneo() {
        const graficoGeracaoConsumoInstantaneoAtualizado = montarGraficoClusteredColumnMensal({
            state: state,
            component: graficoGeracaoConsumoInstantaneo,
            nome: "graficoGeracaoConsumoInstantaneo",
            dados: listaGraficoGeracaoConsumoInstantaneo,
            titulo: "",
            prefixo: "kWh",
            sufixo: "",
        });
        setGraficoGeracaoConsumoInstantaneo(graficoGeracaoConsumoInstantaneoAtualizado);
    }

    function mapearListaGraficoColunasAgrupadas(lista, modoGraficoComparativoComSemSolar) {
        const prefixo = modoGraficoComparativoComSemSolar === "kWh" ? "quantidade" : "valor";

        return {
            dados: [...lista],
            valuesAndNames: [
                { value: `${prefixo}_sem_solar`, name: "Fatura SEM Solar (situação simulada)", stacked: false, linePattern: false },
                { value: `${prefixo}_com_solar`, name: "Fatura COM Solar (situação atual)", stacked: false, linePattern: false },
                { value: `${prefixo}_economia`, name: "Economia", stacked: true, linePattern: true },
            ],
        };
    }

    function atualizarListaGraficoComparativoComSemSolarMensal() {
        const { dados, valuesAndNames } = mapearListaGraficoColunasAgrupadas(listaGraficoComparativoComSemSolarMensal, modoGraficoComparativoComSemSolar);
        const graficoComparativoComSemSolarMensalAtualizado = montarGraficoGroupStackedColumn({
            state: {
                cores: [am4core.color("#0084ff"), am4core.color("#00d185"), am4core.color("#abffe1")],
            },
            component: graficoComparativoComSemSolarMensal,
            nome: "graficoComparativoComSemSolarMensal",
            dados,
            category: "mes",
            valuesAndNames,
            titulo: `Comparativo Mensal de Faturas (Com Solar X Sem Solar) em ${modoGraficoComparativoComSemSolar} no ano de ${filtro.ano_comparativo_com_sem_solar}`,
            fontSizeTitle: 18,
            fontWeightTitle: "bolder",
            prefixo: modoGraficoComparativoComSemSolar === "R$" ? "R$" : "",
            sufixo: modoGraficoComparativoComSemSolar === "kWh" ? "kWh" : "",
            dimensions: "2D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
        });

        setGraficoComparativoComSemSolarMensal(graficoComparativoComSemSolarMensalAtualizado);
    }

    function atualizarListaGraficosComparativosComSemSolarPeriodo() {
        const { dados: dadosEnergia, valuesAndNames: valuesAndNamesEnergia } = mapearListaGraficoColunasAgrupadas(listaGraficoComparativoComSemSolarPeriodo, "kWh");

        const graficoComparativoComSemSolarEnergiaPeriodoAtualizado = montarGraficoGroupStackedColumn({
            state: {
                cores: [am4core.color("#0084ff"), am4core.color("#00d185"), am4core.color("#abffe1")],
            },
            component: graficoComparativoComSemSolarEnergiaPeriodo,
            nome: "graficoComparativoComSemSolarEnergiaPeriodo",
            dados: dadosEnergia,
            category: "periodo",
            valuesAndNames: valuesAndNamesEnergia,
            titulo: `Comparativo Acumulado (Com Solar X Sem Solar) kWh`,
            fontSizeTitle: 18,
            fontWeightTitle: "bolder",
            prefixo: "",
            sufixo: "kWh",
            dimensions: "2D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
            bullets: true,
            centralizarVerticalmente: true,
        });

        setGraficoComparativoComSemSolarEnergiaPeriodo(graficoComparativoComSemSolarEnergiaPeriodoAtualizado);

        const { dados: dadosValor, valuesAndNames: valuesAndNamesValor } = mapearListaGraficoColunasAgrupadas(listaGraficoComparativoComSemSolarPeriodo, "R$");
        const graficoComparativoComSemSolarValorPeriodoAtualizado = montarGraficoGroupStackedColumn({
            state: {
                cores: [am4core.color("#0084ff"), am4core.color("#00d185"), am4core.color("#abffe1")],
            },
            component: graficoComparativoComSemSolarValorPeriodo,
            nome: "graficoComparativoComSemSolarValorPeriodo",
            dados: dadosValor,
            category: "periodo",
            valuesAndNames: valuesAndNamesValor,
            titulo: `Comparativo Acumulado (Com Solar X Sem Solar) R$`,
            fontSizeTitle: 18,
            fontWeightTitle: "bolder",
            prefixo: "R$",
            sufixo: "",
            dimensions: "2D",
            mostrarLegenda: true,
            chartBackground: "#30303d",
            bullets: true,
            centralizarVerticalmente: true,
        });

        setGraficoComparativoComSemSolarValorPeriodo(graficoComparativoComSemSolarValorPeriodoAtualizado);
    }

    async function handleExport({ graficosAtivos }) {
        setLoading(true);
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0, qtd_graficos_lado_a_lado = 1 }) => {
            if (window.innerWidth < 768) {
                el.style.width = 800 - desconto;
            } else {
                el.style.width = (window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto;
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto;
                }
            }

            el.style.width = el.style.width / qtd_graficos_lado_a_lado + "px";
        };

        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.width = 900 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarGrafico = ({ el, qtd_graficos_lado_a_lado = 1 }) => {
            if (el) {
                el.style.marginTop = "0px";
                el.style.fontSize = "0.8rem";
                calcularWidthGrafico({ el, qtd_graficos_lado_a_lado });
                el.style.backgroundColor = "#30303d";
                el.style.overflow = "hidden";
            }
        };
        const formatarTabela = ({ el }) => {
            if (el) {
                calcularWidthTabela({ el });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula) => {
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = "left";

                    // Remove botões dentro do próprio td (fora da div filha)
                    celula.querySelectorAll("button").forEach((btn) => btn.remove());
                });
            }
        };

        if (contentCardRef.current) {
            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            const tituloGraficoGeracaoAvaliacaoProducaoMensal = contentCardRef.current.querySelector("#tituloGraficoGeracaoAvaliacaoProducaoMensal");
            const graficoGeracaoAvaliacaoProducaoMensal = contentCardRef.current.querySelector("#graficoGeracaoAvaliacaoProducaoMensal");
            const tabelaGraficoGeracaoAvaliacaoProducaoMensal = contentCardRef.current.querySelector("#tabelaGraficoGeracaoAvaliacaoProducaoMensal");
            const graficoGeracaoAvaliacaoProducaoAnual = contentCardRef.current.querySelector("#graficoGeracaoAvaliacaoProducaoAnual");

            const graficoGeracaoQuantidadeAnual = contentCardRef.current.querySelector("#graficoGeracaoQuantidadeAnual");
            const graficoGeracaoQuantidadeMensal = contentCardRef.current.querySelector("#graficoGeracaoQuantidadeMensal");
            const tabelaGraficoGeracaoQuantidadeMensal = contentCardRef.current.querySelector("#tabelaGraficoGeracaoQuantidadeMensal");

            const graficoGeracaoSaldo = contentCardRef.current.querySelector("#graficoGeracaoSaldo");
            const tabelaGraficoGeracaoSaldo = contentCardRef.current.querySelector("#tabelaGraficoGeracaoSaldo");
            const tituloGraficoGeracaoComparativoConsumo = contentCardRef.current.querySelector("#tituloGraficoGeracaoComparativoConsumo");
            const graficoGeracaoComparativoConsumo = contentCardRef.current.querySelector("#graficoGeracaoComparativoConsumo");
            const tituloGraficoGeracaoConsumoInstantaneo = contentCardRef.current.querySelector("#tituloGraficoGeracaoConsumoInstantaneo");
            const graficoGeracaoConsumoInstantaneo = contentCardRef.current.querySelector("#graficoGeracaoConsumoInstantaneo");

            const tituloGraficoGeracaoEconomiaTotal = contentCardRef.current.querySelector("#tituloGraficoGeracaoEconomiaTotal");
            const graficoGeracaoEconomiaTotal = contentCardRef.current.querySelector("#graficoGeracaoEconomiaTotal");
            const tituloGraficoGeracaoEconomia = contentCardRef.current.querySelector("#tituloGraficoGeracaoEconomia");
            const graficoGeracaoEconomia = contentCardRef.current.querySelector("#graficoGeracaoEconomia");

            const tituloGraficoGeracaoEconomiaPonta = contentCardRef.current.querySelector("#tituloGraficoGeracaoEconomiaPonta");
            const graficoGeracaoEconomiaPonta = contentCardRef.current.querySelector("#graficoGeracaoEconomiaPonta");

            const graficoGeracaoComparativoComSemSolarMensal = contentCardRef.current.querySelector("#graficoComparativoComSemSolarMensal");
            const tabelaGraficoGeracaoComparativoComSemSolarMensal = contentCardRef.current.querySelector("#tabelaGraficoGeracaoComparativoComSemSolarMensal");
            const graficoComparativoComSemSolarEnergiaPeriodo = contentCardRef.current.querySelector("#graficoComparativoComSemSolarEnergiaPeriodo");
            const graficoComparativoComSemSolarValorPeriodo = contentCardRef.current.querySelector("#graficoComparativoComSemSolarValorPeriodo");

            const tituloGraficoGeracaoRetornoFinanceiro = contentCardRef.current.querySelector("#tituloGraficoGeracaoRetornoFinanceiro");
            const graficoGeracaoRetornoFinanceiro = contentCardRef.current.querySelector("#graficoGeracaoRetornoFinanceiro");
            const tituloGraficoGeracaoAnaliseRetornoFinanceiroAnual = contentCardRef.current.querySelector("#tituloGraficoGeracaoAnaliseRetornoFinanceiroAnual");
            const graficoGeracaoAnaliseRetornoFinanceiroAnual = contentCardRef.current.querySelector("#graficoGeracaoAnaliseRetornoFinanceiroAnual");

            // tituloGraficoGeracaoAvaliacaoProducaoMensal
            formatarGrafico({ el: graficoGeracaoAvaliacaoProducaoMensal });
            formatarTabela({ el: tabelaGraficoGeracaoAvaliacaoProducaoMensal });
            formatarGrafico({ el: graficoGeracaoAvaliacaoProducaoAnual });
            formatarGrafico({ el: graficoGeracaoQuantidadeAnual });
            formatarGrafico({ el: graficoGeracaoQuantidadeMensal });
            formatarTabela({ el: tabelaGraficoGeracaoQuantidadeMensal });
            formatarGrafico({ el: graficoGeracaoSaldo });
            formatarTabela({ el: tabelaGraficoGeracaoSaldo });
            formatarGrafico({ el: graficoGeracaoComparativoConsumo });
            formatarGrafico({ el: graficoGeracaoConsumoInstantaneo });
            formatarGrafico({ el: graficoGeracaoEconomiaTotal });
            formatarGrafico({ el: graficoGeracaoEconomia });
            formatarGrafico({ el: graficoGeracaoEconomiaPonta });
            formatarGrafico({ el: graficoGeracaoComparativoComSemSolarMensal });
            formatarTabela({ el: tabelaGraficoGeracaoComparativoComSemSolarMensal });
            formatarGrafico({ el: graficoComparativoComSemSolarEnergiaPeriodo, qtd_graficos_lado_a_lado: 2 });
            formatarGrafico({ el: graficoComparativoComSemSolarValorPeriodo, qtd_graficos_lado_a_lado: 2 });
            formatarGrafico({ el: graficoGeracaoRetornoFinanceiro });
            formatarGrafico({ el: graficoGeracaoAnaliseRetornoFinanceiroAnual });

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD;font-family: Arial, sans-serif;"><div style="width:100%; height:10%;">
                                       <img src="${base64Cabecalho}" width="100%" />
                                   </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                               <img src="${base64Rodape}" width="100%" />
                                           </div>
                                       </div> `;

            // Captura o HTML com os estilos atualizados
            const htmlGraficoGeracaoAvaliacaoProducaoMensal =
                graficosAtivos.includes("graficoGeracaoAvaliacaoProducaoMensal") && graficoGeracaoAvaliacaoProducaoMensal
                    ? `<div style="padding-left:1%; width:99%; height:42%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      tituloGraficoGeracaoAvaliacaoProducaoMensal.outerHTML +
                      graficoGeracaoAvaliacaoProducaoMensal.outerHTML +
                      tabelaGraficoGeracaoAvaliacaoProducaoMensal.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoGeracaoAvaliacaoProducaoAnual =
                graficosAtivos.includes("graficoGeracaoAvaliacaoProducaoAnual") && graficoGeracaoAvaliacaoProducaoAnual
                    ? `<div style="padding-left:1%; width:99%; height:21%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoGeracaoAvaliacaoProducaoAnual.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoGeracaoQuantidadeAnual =
                graficosAtivos.includes("graficoGeracaoQuantidadeAnual") && graficoGeracaoQuantidadeAnual
                    ? `<div style="padding-left:1%; width:99%; height:21%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoGeracaoQuantidadeAnual.outerHTML +
                      "</div>"
                    : "";
            //---------------------------------------------------------

            const htmlGraficoGeracaoQuantidadeMensal =
                graficosAtivos.includes("graficoGeracaoQuantidadeMensal") && graficoGeracaoQuantidadeMensal
                    ? `<div style="padding-left:1%; width:99%; height:42%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoGeracaoQuantidadeMensal.outerHTML +
                      tabelaGraficoGeracaoQuantidadeMensal.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoGeracaoSaldo =
                graficosAtivos.includes("graficoGeracaoSaldo") && graficoGeracaoSaldo
                    ? `<div style="padding-left:1%; width:99%; height:42%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoGeracaoSaldo.outerHTML +
                      tabelaGraficoGeracaoSaldo.outerHTML +
                      "</div>"
                    : "";
            //---------------------------------------------------------
            const htmlGraficoGeracaoComparativoConsumo =
                graficosAtivos.includes("graficoGeracaoComparativoConsumo") && graficoGeracaoComparativoConsumo
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      tituloGraficoGeracaoComparativoConsumo.outerHTML +
                      graficoGeracaoComparativoConsumo.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoGeracaoConsumoInstantaneo =
                graficosAtivos.includes("graficoGeracaoConsumoInstantaneo") && graficoGeracaoConsumoInstantaneo
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      tituloGraficoGeracaoConsumoInstantaneo.outerHTML +
                      graficoGeracaoConsumoInstantaneo.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoGeracaoEconomiaTotal =
                graficosAtivos.includes("graficoGeracaoEconomiaTotal") && graficoGeracaoEconomiaTotal
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      tituloGraficoGeracaoEconomiaTotal.outerHTML +
                      graficoGeracaoEconomiaTotal.outerHTML +
                      "</div>"
                    : "";
            //---------------------------------------------------------
            const htmlGraficoGeracaoEconomia =
                graficosAtivos.includes("graficoGeracaoEconomia") && graficoGeracaoEconomia
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      tituloGraficoGeracaoEconomia.outerHTML +
                      graficoGeracaoEconomia.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoGeracaoEconomiaPonta =
                graficosAtivos.includes("graficoGeracaoEconomiaPonta") && graficoGeracaoEconomiaPonta
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      tituloGraficoGeracaoEconomiaPonta.outerHTML +
                      graficoGeracaoEconomiaPonta.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoGeracaoComparativoComSemSolarMensal =
                graficosAtivos.includes("graficoComparativoComSemSolarMensal") && graficoGeracaoComparativoComSemSolarMensal
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoGeracaoComparativoComSemSolarMensal.outerHTML +
                      tabelaGraficoGeracaoComparativoComSemSolarMensal.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficosComparativosComSemSolarEnergiaPeriodo =
                graficosAtivos.includes("graficosComparativosComSemSolarPeriodo") && graficoComparativoComSemSolarEnergiaPeriodo && graficoComparativoComSemSolarValorPeriodo
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoComparativoComSemSolarEnergiaPeriodo.outerHTML +
                      graficoComparativoComSemSolarValorPeriodo.outerHTML +
                      "</div>"
                    : "";
            const htmlGraficoGeracaoRetornoFinanceiro =
                graficosAtivos.includes("graficoGeracaoRetornoFinanceiro") && graficoGeracaoRetornoFinanceiro
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      tituloGraficoGeracaoRetornoFinanceiro.outerHTML +
                      graficoGeracaoRetornoFinanceiro.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoGeracaoAnaliseRetornoFinanceiroAnual =
                graficosAtivos.includes("graficoGeracaoAnaliseRetornoFinanceiroAnual") && graficoGeracaoAnaliseRetornoFinanceiroAnual
                    ? `<div style="padding-left:1%; width:99%; height:28%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      tituloGraficoGeracaoAnaliseRetornoFinanceiroAnual.outerHTML +
                      graficoGeracaoAnaliseRetornoFinanceiroAnual.outerHTML +
                      "</div>"
                    : "";

            const listaHtml = [
                { el: htmlGraficoGeracaoAvaliacaoProducaoMensal, h: 42 },
                { el: htmlGraficoGeracaoAvaliacaoProducaoAnual, h: 21 },
                { el: htmlGraficoGeracaoQuantidadeAnual, h: 21 },
                { el: htmlGraficoGeracaoQuantidadeMensal, h: 42 },
                { el: htmlGraficoGeracaoSaldo, h: 42 },
                { el: htmlGraficoGeracaoComparativoConsumo, h: 28 },
                { el: htmlGraficoGeracaoConsumoInstantaneo, h: 28 },
                { el: htmlGraficoGeracaoEconomiaTotal, h: 28 },
                { el: htmlGraficoGeracaoEconomia, h: 28 },
                { el: htmlGraficoGeracaoEconomiaPonta, h: 28 },
                { el: htmlGraficoGeracaoComparativoComSemSolarMensal, h: 28 },
                { el: htmlGraficosComparativosComSemSolarEnergiaPeriodo, h: 28 },
                { el: htmlGraficoGeracaoRetornoFinanceiro, h: 28 },
                { el: htmlGraficoGeracaoAnaliseRetornoFinanceiroAnual, h: 28 },
            ];

            //adiciona cada gráfico em uma página, respeitando o limite de 84% de altura por página
            const paginas = [];
            for (let i = 0; i < listaHtml.length; i++) {
                const atual = listaHtml[i];
                if (!paginas.length && atual.el) {
                    paginas.push([atual]);
                    continue;
                }

                if (paginas.length && atual.el) {
                    if (paginas[paginas.length - 1].reduce((acc, atual) => (acc += atual.h), 0) + atual.h <= 84) {
                        paginas[paginas.length - 1].push(atual);
                    } else {
                        paginas.push([atual]);
                    }
                }
            }

            let html = "";
            for (let i = 0; i < paginas.length; i++) {
                html += htmlCabecalho;
                const pagina = paginas[i];
                let heightRestante = 84;
                const ultimoItem = pagina.pop();
                for (let j = 0; j < pagina.length; j++) {
                    const item = paginas[i][j];
                    if (item.el && heightRestante >= item.h) {
                        heightRestante -= item.h;
                        html += item.el;
                    }
                }

                //se sobrou espaço adiciona mais altura no ultimo item da página
                if (ultimoItem) {
                    const elemento = heightRestante > 0 ? ultimoItem.el.substring(0, 31) + heightRestante + ultimoItem.el.substring(33) : ultimoItem.el;
                    html += elemento;
                }

                html += htmlRodape;
            }
            // Gera o relatório com o HTML atualizado
            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            setLoading(false);
            setAguardando(true);
            setAguardando(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    let demandaMesInicial = contratoDemanda && contratoDemanda.competencia_inicio ? String(contratoDemanda.competencia_inicio).substring(4, 6) : "";
    let demandaMesFinal = contratoDemanda && contratoDemanda.competencia_fim ? String(contratoDemanda.competencia_fim).substring(4, 6) : "";

    let anos = [];
    listaGraficoGeracaoQuantidadeAnual.forEach((item) => {
        item.anos.forEach((ano) => {
            if (anos.filter((itemAno) => itemAno == ano.ano).length <= 0) {
                anos.push(ano.ano);
            }
        });
    });

    anos = anos.sort((a, b) => (a < b ? -1 : 1));

    let listaGraficoGeracaoAvaliacaoProducaoAnualMapeada = listaGraficoGeracaoAvaliacaoProducaoAnual.map((item) => ({
        ...item,
        anos: item.anos.filter((itemAno) => !itemAno.ano.includes("indice")),
    }));

    let desempenhoTotalAnualProjetado = 0;
    let desempenhoTotalAnualGerado = 0;
    listaGraficoGeracaoAvaliacaoProducaoAnualMapeada.forEach((item, i) => {
        let projetado = item.anos.filter((ano) => ano.ano == "Projetado Atual")[0] ? parseFloat(item.anos.filter((ano) => ano.ano == "Projetado Atual")[0].valor) : 0;
        let gerados = item.anos.filter((ano) => ano.ano == new Date().getFullYear() && parseFloat(ano.valor) > 0);

        if (gerados.length > 0) {
            desempenhoTotalAnualProjetado += projetado;
        }
        gerados.forEach((gerado) => {
            desempenhoTotalAnualGerado += parseFloat(gerado.valor);
        });
    });

    let desempenhoAnual = desempenhoTotalAnualGerado > 0 && desempenhoTotalAnualProjetado > 0 ? (desempenhoTotalAnualGerado * 100) / desempenhoTotalAnualProjetado : 0;

    let desempenhoTotalGlobalProjetado = 0;
    let desempenhoTotalGlobalGerado = 0;
    listaGraficoGeracaoAvaliacaoProducaoAnual.forEach((item, i) => {
        let projetados = item.anos.filter((ano) => ano.ano.includes("indice"));
        let gerados = item.anos.filter((ano) => ano.ano != "Projetado Inicial" && ano.ano != "Projetado Atual" && !ano.ano.includes("indice"));

        projetados.forEach((projetado) => {
            if (gerados.filter((gerado) => projetado.ano.includes(gerado.ano) && gerado.valor > 0).length > 0) {
                desempenhoTotalGlobalProjetado += parseFloat(projetado.valor);
            }
        });

        gerados.forEach((gerado) => {
            desempenhoTotalGlobalGerado += parseFloat(gerado.valor);
        });
    });

    let desempenhoGlobal = desempenhoTotalGlobalGerado > 0 ? (desempenhoTotalGlobalGerado * 100) / desempenhoTotalGlobalProjetado : 0;

    let totalAntes = 0;
    let totalDepois = 0;
    listaGraficoGeracaoComparativoConsumo.forEach((item, i) => {
        let antes = item.tipos.filter((tipo) => tipo.tipo == "Antes")[0] ? parseFloat(item.tipos.filter((tipo) => tipo.tipo == "Antes")[0].valor) : 0;
        let depois = item.tipos.filter((tipo) => tipo.tipo == "Depois")[0] ? parseFloat(item.tipos.filter((tipo) => tipo.tipo == "Depois")[0].valor) : 0;

        if (antes && depois) {
            totalAntes += antes;
            totalDepois += depois;
        }
    });

    let antesDepois = totalDepois > 0 ? (totalDepois * 100) / totalAntes : 0;

    let economia = 0;
    listaGraficoGeracaoEconomia.forEach((item, i) => {
        item.anos.forEach((ano, i) => {
            economia += parseFloat(ano.valor);
        });
    });

    const totalInvestido = parseFloat((listaGeracaoContrato[listaGeracaoContrato.length - 1] || {}).valor_investido) || 0; //a ultima tem o acumulado de todos os anos
    let retornoFinanceiro = economia > 0 && totalInvestido > 0 ? (economia * 100) / totalInvestido : 0;

    let economiaPonta = 0;
    listaGraficoGeracaoEconomiaPonta.forEach((item, i) => {
        item.anos.forEach((ano, i) => {
            economiaPonta += parseFloat(ano.valor);
        });
    });

    function renderizarLinhasTabelaGeracaoProjetadaXRealidade({ somenteProjetado, somenteAnos }) {
        const linhas = (listaGraficoGeracaoAvaliacaoProducaoAnual[0] && listaGraficoGeracaoAvaliacaoProducaoAnual[0].anos) || [];

        const linhaDesempenhoMensal = ({ ano, listaGraficoGeracaoAvaliacaoProducaoAnual, totalProjetado, totalGerado }) => {
            const projetadoAtual = listaGraficoGeracaoAvaliacaoProducaoAnual
                .map((item) =>
                    item.anos.find((anoMes) => anoMes.ano == "Projetado Atual") ? { mes: item.mes, ...item.anos.find((anoMes) => anoMes.ano == "Projetado Atual") } : null
                )
                .filter((item) => item);
            return (
                <Tr style={{ backgroundColor: "#006d2e" }} key={`Desempenho mensal (${ano.ano})`}>
                    <Td color="#fff">Desempenho mensal ({ano.ano})</Td>
                    {listaGraficoGeracaoAvaliacaoProducaoAnual.map((mes) => {
                        if (mes.anos.find((anoMes) => anoMes.ano == ano.ano)) {
                            return mes.anos
                                .filter((anoMes) => anoMes.ano == ano.ano)
                                .map((anoMes) => {
                                    const projetadoMes = projetadoAtual.find((item) => item.mes == mes.mes);
                                    const desempenho = projetadoMes ? ((parseFloat(anoMes.valor || 0) * 100) / parseFloat(projetadoMes.valor || 0)).toFixed(2) + "%" : "0%";

                                    return (
                                        <Td key={anoMes.ano} alignCenter color="#fff">
                                            {desempenho.replace(".", ",")}
                                        </Td>
                                    );
                                });
                        } else {
                            return (
                                <Td key={ano} alignCenter color="#fff">
                                    0,00
                                </Td>
                            );
                        }
                    })}

                    {(() => {
                        let listaMeses = [];
                        for (let i = listaGraficoGeracaoAvaliacaoProducaoAnual.length; i < 12; i++) {
                            listaMeses.push(i);
                        }

                        return listaMeses.map((mes) => (
                            <Td key={mes} alignCenter color="#fff">
                                0,00
                            </Td>
                        ));
                    })()}
                    <Td alignCenter color="#fff">
                        {totalProjetado > 0 ? `${((totalGerado * 100) / totalProjetado).toFixed(2).replace(".", ",")}%` : "-"}
                    </Td>
                </Tr>
            );
        };
        return linhas
            .filter((linha) => {
                if (linha.ano.includes("indice")) return false;
                if (somenteProjetado) return linha.ano.includes("Projetado");
                if (somenteAnos) return !linha.ano.includes("Projetado");
            })
            .sort((a, b) => {
                if (somenteProjetado) return b.ano.localeCompare(a.ano, undefined, { sensitivity: "base" });
                if (somenteAnos) return a.ano.ano - b.ano.ano;
            })
            .map((ano, i, listaMap) => {
                let totalGerado = 0;
                let totalProjetado = 0;

                //Buscar Projetado
                listaGraficoGeracaoAvaliacaoProducaoAnual.forEach((mes) => {
                    mes.anos
                        .filter((anoMes) => anoMes.ano == `indice-${ano.ano}`)
                        .forEach((anoMes) => {
                            if (mes.anos.find((anoMes) => anoMes.ano == ano.ano && anoMes.valor > 0)) {
                                totalProjetado += parseFloat(anoMes.valor || 0);
                            }
                        });
                });

                return (
                    <>
                        <Tr key={ano.ano}>
                            <Td color="#fff">{ano.ano}</Td>
                            {listaGraficoGeracaoAvaliacaoProducaoAnual.map((mes) => {
                                if (mes.anos.find((anoMes) => anoMes.ano == ano.ano)) {
                                    return mes.anos
                                        .filter((anoMes) => anoMes.ano == ano.ano)
                                        .map((anoMes) => {
                                            totalGerado += parseFloat(anoMes.valor || 0);

                                            return (
                                                <Td key={anoMes.ano} alignCenter color="#fff">
                                                    {parseFloat(anoMes.valor || 0)
                                                        .toFixed(2)
                                                        .replace(".", ",")}
                                                </Td>
                                            );
                                        });
                                } else {
                                    return (
                                        <Td key={ano} alignCenter color="#fff">
                                            0,00
                                        </Td>
                                    );
                                }
                            })}

                            {(() => {
                                let listaMeses = [];
                                for (let i = listaGraficoGeracaoAvaliacaoProducaoAnual.length; i < 12; i++) {
                                    listaMeses.push(i);
                                }

                                return listaMeses.map((mes) => (
                                    <Td key={mes} alignCenter color="#fff">
                                        0,00
                                    </Td>
                                ));
                            })()}
                            <Td alignCenter color="#fff">
                                {totalProjetado > 0 ? `${((totalGerado * 100) / totalProjetado).toFixed(2).replace(".", ",")}%` : "-"}
                            </Td>
                        </Tr>
                        {i == listaMap.length - 1 && somenteAnos
                            ? linhaDesempenhoMensal({
                                  ano,
                                  listaGraficoGeracaoAvaliacaoProducaoAnual,
                                  totalProjetado,
                                  totalGerado,
                              })
                            : null}
                    </>
                );
            });
    }

    const exibirGraficoEconomiaPonta = !!(
        buscarPropriedadeUcFiltrada() &&
        (buscarPropriedadeUcFiltrada("geracao") || buscarPropriedadeUcFiltrada("remota")) &&
        ([1, 4].includes(parseInt(buscarPropriedadeUcFiltrada("id_grupo_faturamento"))) || buscarPropriedadeUcFiltrada("id_grupo_faturamento") == 3)
    );
    const exibirGraficosGeradoraRemota = !!(!buscarPropriedadeUcFiltrada() || buscarPropriedadeUcFiltrada("geracao") || buscarPropriedadeUcFiltrada("remota"));
    const exibirGraficosGeradora = !!(!buscarPropriedadeUcFiltrada() || buscarPropriedadeUcFiltrada("geracao"));

    const listaGraficosDisponiveis = ["graficoGeracaoComparativoConsumo", "graficoComparativoComSemSolarMensal", "graficosComparativosComSemSolarPeriodo"];

    if (exibirGraficoEconomiaPonta) {
        listaGraficosDisponiveis.push("graficoGeracaoEconomiaPonta");
    }
    if (exibirGraficosGeradoraRemota) {
        listaGraficosDisponiveis.push("graficoGeracaoEconomiaTotal", "graficoGeracaoSaldo");
    }
    if (exibirGraficosGeradora) {
        listaGraficosDisponiveis.push(
            "graficoGeracaoAvaliacaoProducaoMensal",
            "graficoGeracaoAvaliacaoProducaoAnual",
            "graficoGeracaoQuantidadeAnual",
            "graficoGeracaoQuantidadeMensal",
            "graficoGeracaoConsumoInstantaneo",
            "graficoGeracaoRetornoFinanceiro",
            "graficoGeracaoAnaliseRetornoFinanceiroAnual"
        );
    }
    let totalPercentualGeracao = 0;

    const mediaSemSolar = listaGraficoComparativoComSemSolarMensal.length //divide pela qtd de elementos com valor
        ? listaGraficoComparativoComSemSolarMensal.reduce((acc, item) => (acc += parseFloat(item.valor_sem_solar) || 0), 0) / listaGraficoComparativoComSemSolarMensal.length
        : 0;

    const mediaComSolar = listaGraficoComparativoComSemSolarMensal.length //divide pela qtd de elementos com valor
        ? listaGraficoComparativoComSemSolarMensal.reduce((acc, item) => (acc += parseFloat(item.valor_com_solar) || 0), 0) / listaGraficoComparativoComSemSolarMensal.length
        : 0;

    const mediaEconomia = listaGraficoComparativoComSemSolarMensal.length //divide pela qtd de elementos com valor
        ? listaGraficoComparativoComSemSolarMensal.reduce((acc, item) => (acc += parseFloat(item.valor_economia) || 0), 0) / listaGraficoComparativoComSemSolarMensal.length
        : 0;

    const currentYear = new Date().getFullYear();
    const listaAnos = Array.from({ length: 20 }, (_, i) => {
        const year = currentYear - i; // inverte a ordem
        return { id: year.toString(), valor: year.toString() };
    });

    return (
        <div ref={contentCardRef}>
            {loading && <Loading />}
            <ContentCard style={{ color: "#fff", padding: "8px 8px 0px", marginBottom: 0, boxShadow: "none" }}>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"light"}
                                icon={"fa fa-file-export"}
                                event={() => {
                                    if (!filtro.id_cliente) {
                                        return setInfo("Selecione um cliente e clique em atualizar antes de exportar");
                                    }
                                    setModalExportacaoAberto(true);
                                }}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)}>
                            <ExportAnalise listaGraficosDisponiveis={listaGraficosDisponiveis} />
                        </ModalAlert>
                    ) : null}
                </ContentCardBody>
            </ContentCard>
            {exibirGraficosGeradora && (
                <>
                    <ContentCard style={{ color: "#fff", padding: "0 8px 8px", boxShadow: "none" }}>
                        <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                            <div id="tituloGraficoGeracaoAvaliacaoProducaoMensal" style={{ color: "#fff", textAlign: "center" }}>
                                <div style={{ marginTop: 10, fontSize: 16 }}>Geração Projetada X Realidade (kWh)</div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                                    <div style={{ backgroundColor: "#006d2e", width: 300, paddingTop: 8, paddingBottom: 8 }}>
                                        Desempenho Global: {FormatUtils.formatarValorTela(desempenhoGlobal || 0, 2)}%
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
                                    <div style={{ backgroundColor: "#006d2e", width: 300, paddingTop: 8, paddingBottom: 8 }}>
                                        Desempenho Anual: {FormatUtils.formatarValorTela(desempenhoAnual || 0, 2)}%
                                    </div>
                                </div>
                            </div>
                            <div id="graficoGeracaoAvaliacaoProducaoMensal" style={{ width: "100%", minWidth: "890px", height: 400, marginTop: -20 }}></div>
                            <div style={{ minWidth: "890px" }}>
                                <Table responsive id="tabelaGraficoGeracaoAvaliacaoProducaoMensal">
                                    <THead>
                                        <Tr>
                                            <Th width={200}>Produção em kWh</Th>
                                            <Th alignCenter>Janeiro</Th>
                                            <Th alignCenter>Fevereiro</Th>
                                            <Th alignCenter>Março</Th>
                                            <Th alignCenter>Abril</Th>
                                            <Th alignCenter>Maio</Th>
                                            <Th alignCenter>Junho</Th>
                                            <Th alignCenter>Julho</Th>
                                            <Th alignCenter>Agosto</Th>
                                            <Th alignCenter>Setembro</Th>
                                            <Th alignCenter>Outubro</Th>
                                            <Th alignCenter>Novembro</Th>
                                            <Th alignCenter>Dezembro</Th>
                                            <Th alignCenter>Desempenho</Th>
                                        </Tr>
                                    </THead>
                                    <TBody>
                                        {renderizarLinhasTabelaGeracaoProjetadaXRealidade({
                                            somenteProjetado: true,
                                            somenteAnos: false,
                                        })}
                                        {renderizarLinhasTabelaGeracaoProjetadaXRealidade({
                                            somenteProjetado: false,
                                            somenteAnos: true,
                                        })}
                                    </TBody>
                                </Table>
                            </div>
                        </ContentCardBody>
                    </ContentCard>
                    <ContentCard style={{ color: "#fff", padding: 8 }}>
                        <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                            <div id="graficoGeracaoAvaliacaoProducaoAnual" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                        </ContentCardBody>
                    </ContentCard>
                    <ContentCard style={{ color: "#fff", padding: 8 }}>
                        <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                            <div id="graficoGeracaoQuantidadeAnual" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                        </ContentCardBody>
                    </ContentCard>
                    <ContentCard style={{ color: "#fff", padding: 8 }}>
                        <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                            <div id="graficoGeracaoQuantidadeMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                            <div style={{ minWidth: "890px" }}>
                                <Table responsive id="tabelaGraficoGeracaoQuantidadeMensal">
                                    <THead>
                                        <Tr>
                                            <Th width={200}>UC</Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "01" ? "#66bb6a" : demandaMesFinal == "01" ? "#ef5350" : null }}>
                                                Janeiro
                                                {demandaMesInicial == "01" ? " (I)" : demandaMesFinal == "01" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "02" ? "#66bb6a" : demandaMesFinal == "02" ? "#ef5350" : null }}>
                                                Fevereiro
                                                {demandaMesInicial == "02" ? " (I)" : demandaMesFinal == "02" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "03" ? "#66bb6a" : demandaMesFinal == "03" ? "#ef5350" : null }}>
                                                Março
                                                {demandaMesInicial == "03" ? " (I)" : demandaMesFinal == "03" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "04" ? "#66bb6a" : demandaMesFinal == "04" ? "#ef5350" : null }}>
                                                Abril
                                                {demandaMesInicial == "04" ? " (I)" : demandaMesFinal == "04" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "05" ? "#66bb6a" : demandaMesFinal == "05" ? "#ef5350" : null }}>
                                                Maio
                                                {demandaMesInicial == "05" ? " (I)" : demandaMesFinal == "05" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "06" ? "#66bb6a" : demandaMesFinal == "06" ? "#ef5350" : null }}>
                                                Junho
                                                {demandaMesInicial == "06" ? " (I)" : demandaMesFinal == "06" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "07" ? "#66bb6a" : demandaMesFinal == "07" ? "#ef5350" : null }}>
                                                Julho
                                                {demandaMesInicial == "07" ? " (I)" : demandaMesFinal == "07" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "08" ? "#66bb6a" : demandaMesFinal == "08" ? "#ef5350" : null }}>
                                                Agosto
                                                {demandaMesInicial == "08" ? " (I)" : demandaMesFinal == "08" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "09" ? "#66bb6a" : demandaMesFinal == "09" ? "#ef5350" : null }}>
                                                Setembro
                                                {demandaMesInicial == "09" ? " (I)" : demandaMesFinal == "09" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "10" ? "#66bb6a" : demandaMesFinal == "10" ? "#ef5350" : null }}>
                                                Outubro
                                                {demandaMesInicial == "10" ? " (I)" : demandaMesFinal == "10" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "11" ? "#66bb6a" : demandaMesFinal == "11" ? "#ef5350" : null }}>
                                                Novembro
                                                {demandaMesInicial == "11" ? " (I)" : demandaMesFinal == "11" ? " (F)" : ""}
                                            </Th>
                                            <Th alignCenter style={{ backgroundColor: demandaMesInicial == "12" ? "#66bb6a" : demandaMesFinal == "12" ? "#ef5350" : null }}>
                                                Dezembro
                                                {demandaMesInicial == "12" ? " (I)" : demandaMesFinal == "12" ? " (F)" : ""}
                                            </Th>
                                        </Tr>
                                    </THead>
                                    <TBody>
                                        {(anos || [])
                                            .sort((a, b) => (a.ano < b.ano ? -1 : 1))
                                            .map((ano, i) => (
                                                <Tr key={i}>
                                                    <Td color="#fff">{ano}</Td>
                                                    {listaGraficoGeracaoQuantidadeAnual.map((mes) => {
                                                        if (mes.anos.filter((anoMes) => anoMes.ano == ano).length > 0) {
                                                            return mes.anos
                                                                .filter((anoMes) => anoMes.ano == ano)
                                                                .map((anoMes) => {
                                                                    return (
                                                                        <Td key={anoMes.ano} alignCenter color="#fff">
                                                                            {parseFloat(anoMes.valor || 0)
                                                                                .toFixed(2)
                                                                                .replace(".", ",")}
                                                                        </Td>
                                                                    );
                                                                });
                                                        } else {
                                                            return (
                                                                <Td key={ano} alignCenter color="#fff">
                                                                    0,00
                                                                </Td>
                                                            );
                                                        }
                                                    })}

                                                    {(() => {
                                                        let listaMeses = [];
                                                        for (var i = listaGraficoGeracaoQuantidadeAnual.length; i < 12; i++) {
                                                            listaMeses.push(i);
                                                        }

                                                        return listaMeses.map((mes) => (
                                                            <Td key={mes} alignCenter color="#fff">
                                                                0,00
                                                            </Td>
                                                        ));
                                                    })()}
                                                </Tr>
                                            ))}
                                    </TBody>
                                </Table>
                            </div>
                        </ContentCardBody>
                    </ContentCard>
                </>
            )}

            {exibirGraficosGeradoraRemota && (
                <ContentCard style={{ color: "#fff", padding: exibirGraficosGeradoraRemota ? "0 8px 8px" : 8 }}>
                    <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                        <div id="graficoGeracaoSaldo" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                    </ContentCardBody>

                    <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto" }}>
                        {filtro.unidades_consumidoras.length != 1 && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "fit-content",
                                    height: 35,
                                    fontWeight: 500,
                                    color: "#f00",
                                    paddingRight: 10,
                                    borderRadius: 10,
                                    background: "#000",
                                }}
                            >
                                <span className="pl-2" style={{ marginTop: -3 }}>
                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                </span>
                                <span className="pl-2">Selecione apenas uma UC para visualizar a tabela de saldos</span>
                            </div>
                        )}
                        <Table responsive minWidth={890} id="tabelaGraficoGeracaoSaldo">
                            <THead>
                                <NewTr noButtons>
                                    <Th backgroundColor="#00cc85" colSpan={2} alignCenter>
                                        Índice de Consumo Antes x Depois (%)
                                    </Th>
                                    <Th backgroundColor="#0e92f8" colSpan={4} alignCenter>
                                        Saldos
                                    </Th>
                                </NewTr>
                                <NewTr noButtons>
                                    <Th backgroundColor="#00cc85">Unidade Consumidora</Th>
                                    <Th alignCenter backgroundColor="#00cc85">
                                        Índice
                                    </Th>
                                    <Th alignCenter backgroundColor="#0e92f8">
                                        Saldo Anterior
                                    </Th>
                                    <Th alignCenter backgroundColor="#0e92f8">
                                        Saldo Atual
                                    </Th>
                                    <Th alignCenter backgroundColor="#0e92f8"></Th>
                                    <Th alignCenter backgroundColor="#0e92f8">
                                        Anexo G
                                    </Th>
                                </NewTr>
                            </THead>
                            {filtro.unidades_consumidoras.length == 1 && (
                                <TBody>
                                    {listaIndiceAntesDepois.map((item, i) => {
                                        totalPercentualGeracao += item.percentual_geracao;
                                        let corSaldo = "#fff";
                                        let icone = iconeIgualAzul;
                                        if (item.saldoAtual > item.saldoAnterior) {
                                            corSaldo = "#006d2e";
                                            icone = iconeMaiorVerde;
                                        }
                                        if (item.saldoAtual < item.saldoAnterior) {
                                            corSaldo = "#d02525";
                                            icone = iconeMenorVermelho;
                                        }

                                        return (
                                            <NewTr key={item.nome_unidade_consumidora} noButtons style={{ color: "#fff", backgroundColor: i % 2 == 0 ? "#f2f2f2" : "#fff" }}>
                                                <Td color="#FFF" minWidth={200}>
                                                    {item.nome_unidade_consumidora}
                                                </Td>
                                                <Td color="#FFF" alignCenter backgroundColor="#0b5139">
                                                    {adicionarPontosMilhar(item.indiceAntesDepois)}%
                                                </Td>
                                                <Td color="#FFF" alignCenter>
                                                    {adicionarPontosMilhar(item.saldoAnterior)}
                                                </Td>
                                                <Td color="#FFF" alignCenter style={{ color: corSaldo }}>
                                                    {adicionarPontosMilhar(item.saldoAtual)}
                                                </Td>
                                                <Td color="#FFF" style={{ color: corSaldo }}>
                                                    <div style={{ backgroundColor: "#FFF", height: 12, width: 12, display: "flex", justifyContent: "center", borderRadius: 5 }}>
                                                        <img src={icone} style={{ height: 20, width: 20, marginInline: 10, marginTop: -4 }} alt=""></img>
                                                    </div>
                                                </Td>
                                                <Td color="#FFF" alignCenter>
                                                    {adicionarPontosMilhar(item.percentual_geracao)}%
                                                </Td>
                                            </NewTr>
                                        );
                                    })}
                                    <NewTr noButtons>
                                        <Td colSpan={2} backgroundColor="#00cc85"></Td>
                                        <Td colSpan={3} backgroundColor="#0e92f8"></Td>
                                        <Td color="#FFF" backgroundColor="#0e92f8" alignCenter>
                                            <b style={{ paddingInline: 10 }}>Total:</b> {adicionarPontosMilhar(totalPercentualGeracao)}%
                                        </Td>
                                    </NewTr>
                                </TBody>
                            )}
                        </Table>
                    </ContentCardBody>
                </ContentCard>
            )}

            <ContentCard
                style={{
                    color: "#fff",
                    padding: 8,
                    display: !buscarPropriedadeUcFiltrada() || buscarPropriedadeUcFiltrada("geracao") || buscarPropriedadeUcFiltrada("remota") ? "" : "none",
                }}
            >
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                    <div id="tituloGraficoGeracaoComparativoConsumo" style={{ color: "#fff", textAlign: "center" }}>
                        <div style={{ marginTop: 10, fontSize: 16 }}>Consumo (kWh): Antes X Depois</div>
                        <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                            <div style={{ backgroundColor: "#006d2e", width: 300, paddingTop: 8, paddingBottom: 8 }}>
                                Consumo no Período: {FormatUtils.formatarValorTela(antesDepois || 0, 2)}%
                            </div>
                        </div>
                    </div>
                    <div id="graficoGeracaoComparativoConsumo" style={{ width: "100%", minWidth: "890px", height: 400, marginTop: -20 }}></div>
                </ContentCardBody>
            </ContentCard>
            {exibirGraficosGeradora && (
                <ContentCard style={{ color: "#fff", padding: 8 }}>
                    <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                        <div id="tituloGraficoGeracaoConsumoInstantaneo" style={{ marginTop: 10, fontSize: 16, color: "#fff", textAlign: "center" }}>
                            Simulação de Consumo Instantâneo (kWh)
                        </div>
                        <div id="graficoGeracaoConsumoInstantaneo" style={{ width: "100%", minWidth: "890px", height: 400, marginTop: -20 }}></div>
                    </ContentCardBody>
                </ContentCard>
            )}
            {exibirGraficosGeradoraRemota && (
                <>
                    <ContentCard style={{ color: "#fff", padding: 8 }}>
                        {/* se só tem uma unidade, que é a propria geradora, não precisa aparecer */}
                        <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                            <div id="tituloGraficoGeracaoEconomiaTotal" style={{ marginTop: 10, marginBottom: 20, fontSize: 16, color: "#fff", textAlign: "center" }}>
                                <Row>
                                    <Grid cols="12 4 4 4"></Grid>
                                    <Grid cols="12 4 4 4" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        Economia Anual (R$)
                                    </Grid>
                                    <Grid cols="12 4 4 4">
                                        {ucFiltradaComRemotas.length > 1 ? (
                                            <Row>
                                                <Grid cols="12 12 12 12">
                                                    <Button
                                                        title={exibirUCs ? "Ocultar UCs que compõem os gráficos" : "Exibir UCs que compõem os gráficos"}
                                                        text={
                                                            <div>
                                                                {exibirUCs ? <i className="fas fa-eye-slash mr-2"></i> : <i className="fas fa-home mr-2"></i>}
                                                                {exibirUCs ? "Ocultar UCs que compõem os gráficos" : "Exibir UCs que compõem os gráficos"}
                                                            </div>
                                                        }
                                                        hoverStyle={{ filter: "brightness(1.1)" }}
                                                        style={{
                                                            background: "linear-gradient(rgb(59 155 235), rgb(200 177 255))",
                                                            border: "2px solid #FFFFFF",
                                                            borderRadius: "0.3rem",
                                                            color: "#fff",
                                                            margin: window.innerWidth < 768 ? "0 0 2px 0" : "27px 0 2px 0",
                                                            padding: 8,
                                                        }}
                                                        disabled={false}
                                                        event={() => {
                                                            setExibirUCs(!exibirUCs);
                                                        }}
                                                    />
                                                </Grid>
                                                {exibirUCs && (
                                                    <Select
                                                        style={{ backgroundColor: "#30303d", color: "#FFF", margin: 0, fontSize: 14 }}
                                                        options={ucFiltradaComRemotas.filter((uc) => !filtroUCs.find((ucFiltro) => ucFiltro.value == uc.id))}
                                                        label=""
                                                        cols="12 12 12 12"
                                                        placeholder="Selecione as UCs"
                                                        isMulti={true}
                                                        value={filtroUCs}
                                                        onChange={(ucsSelecionadas) => {
                                                            setFiltroUCs([...ucsSelecionadas]);
                                                        }}
                                                    />
                                                )}
                                            </Row>
                                        ) : null}
                                    </Grid>
                                </Row>
                            </div>
                            <div id="graficoGeracaoEconomiaTotal" style={{ width: "100%", minWidth: "890px", height: 400, marginTop: -20 }}></div>
                        </ContentCardBody>
                        <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                            <div id="tituloGraficoGeracaoEconomia" style={{ color: "#fff", textAlign: "center" }}>
                                <div style={{ marginTop: 10, fontSize: 16 }}>Economia Mensal (R$)</div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                                    <div style={{ backgroundColor: "#006d2e", width: 300, paddingTop: 8, paddingBottom: 8 }}>
                                        Economia Total: R$ {FormatUtils.formatarValorTela(economia || 0, 2)}
                                    </div>
                                </div>
                            </div>
                            <div id="graficoGeracaoEconomia" style={{ width: "100%", minWidth: "890px", height: 400, marginTop: -20 }}></div>
                        </ContentCardBody>
                    </ContentCard>
                </>
            )}

            {exibirGraficoEconomiaPonta && (
                <ContentCard style={{ color: "#fff", padding: 8 }}>
                    <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                        <div id="tituloGraficoGeracaoEconomiaPonta" style={{ color: "#fff", textAlign: "center" }}>
                            <div style={{ marginTop: 10, fontSize: 16 }}>Economia Horário Ponta (R$)</div>
                            <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                                <div style={{ backgroundColor: "#006d2e", width: 300, paddingTop: 8, paddingBottom: 8 }}>
                                    Economia Ponta Total: R$ {FormatUtils.formatarValorTela(economiaPonta || 0, 2)}
                                </div>
                            </div>
                        </div>
                        <div id="graficoGeracaoEconomiaPonta" style={{ width: "100%", minWidth: "890px", height: 400, marginTop: -20 }}></div>
                    </ContentCardBody>
                </ContentCard>
            )}
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                    <Row style={{ paddingBlock: 20 }}>
                        <Grid cols="12 12 6 4">
                            <Button
                                text="Mostrar comparativo mensal de Energia (kWh)"
                                type={modoGraficoComparativoComSemSolar === "kWh" ? "primary" : "light"}
                                iconStyle={{ marginRight: 12 }}
                                solid={modoGraficoComparativoComSemSolar === "kWh"}
                                icon={modoGraficoComparativoComSemSolar === "kWh" ? "fa fa-check-square" : "fa fa-square"}
                                event={() => {
                                    setModoGraficoComparativoComSemSolar("kWh");
                                }}
                            />
                        </Grid>
                        <Grid cols="12 12 6 4">
                            <Button
                                text="Mostrar comparativo mensal de Valores (R$)"
                                type={modoGraficoComparativoComSemSolar === "R$" ? "primary" : "light"}
                                solid={modoGraficoComparativoComSemSolar === "R$"}
                                iconStyle={{ marginRight: 12 }}
                                icon={modoGraficoComparativoComSemSolar === "R$" ? "fa fa-check-square" : "fa fa-square"}
                                event={() => {
                                    setModoGraficoComparativoComSemSolar("R$");
                                }}
                            />
                        </Grid>
                        <Grid
                            cols="2 2 9 2"
                            style={{ paddingLeft: window.innerWidth < 768 ? 0 : 20, textAlign: "end", fontSize: "1.2rem", fontWeight: "bold", alignSelf: "center" }}
                        >
                            Ano
                        </Grid>
                        <Grid cols="10 10 3 2">
                            <Select
                                style={{ backgroundColor: "#30303d", color: "#FFF", margin: 0 }}
                                cols="12 12 12 12"
                                name="ano_comparativo_com_sem_solar"
                                options={listaAnos}
                                label=""
                                placeholder="Selecione o ano"
                                value={props.filtro.ano_comparativo_com_sem_solar}
                                isClearable={false}
                                isSearchable={false}
                                onChange={(value) => {
                                    props.setFiltro({ ...props.filtro, ano_comparativo_com_sem_solar: value });
                                }}
                            />
                        </Grid>
                    </Row>
                    <div style={{ minWidth: "890px" }}>
                        <div id="graficoComparativoComSemSolarMensal" style={{ width: "100%", height: "400px" }}></div>
                        <Table responsive id="tabelaGraficoGeracaoComparativoComSemSolarMensal">
                            <THead>
                                <Tr>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Descrição
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Janeiro
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Fevereiro
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Março
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Abril
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Maio
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Junho
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Julho
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Agosto
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Setembro
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Outubro
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Novembro
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Dezembro
                                    </Th>
                                    <Th style={{ fontSize: "0.8rem" }} alignCenter>
                                        Média
                                    </Th>
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr>
                                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                        Fatura SEM Solar (situação Simulada)
                                    </Td>
                                    {listaGraficoComparativoComSemSolarMensal.map((item, i) => (
                                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} key={item.mes} color="#fff">
                                            <div title={`Impostos: R$ ${adicionarPontosMilhar(item.valor_imposto_cativo || 0, 6)}`}>
                                                {parseFloat(item.valor_sem_solar || 0)
                                                    .toFixed(2)
                                                    .replace(".", ",")}
                                            </div>
                                        </Td>
                                    ))}
                                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                        {mediaSemSolar.toFixed(2).replace(".", ",")}
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                        Fatura COM Solar (situação Atual)
                                    </Td>
                                    {listaGraficoComparativoComSemSolarMensal.map((item, i) => (
                                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} key={item.mes} color="#fff">
                                            {parseFloat(item.valor_com_solar || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                        {mediaComSolar.toFixed(2).replace(".", ",")}
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                        Economia
                                    </Td>
                                    {listaGraficoComparativoComSemSolarMensal.map((item, i) => (
                                        <Td fontSize="0.8rem" alignCenter paddingLeft={4} key={item.mes} color="#fff">
                                            {parseFloat(item.valor_economia || 0)
                                                .toFixed(2)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                    <Td fontSize="0.8rem" alignCenter paddingLeft={4} color="#fff">
                                        {mediaEconomia.toFixed(2).replace(".", ",")}
                                    </Td>
                                </Tr>
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <Row style={{ paddingBlock: 20 }}>
                    <Grid cols="6 4 3 2">
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                            <DatePicker
                                variant="inline"
                                openTo="year"
                                views={["year", "month"]}
                                label="De"
                                autoOk
                                value={
                                    filtro.competencia_inicial_geracao_comparativo_com_sem_solar
                                        ? `${String(filtro.competencia_inicial_geracao_comparativo_com_sem_solar).substring(0, 4)}/${String(
                                              filtro.competencia_inicial_geracao_comparativo_com_sem_solar
                                          ).substring(4, 6)}/01 12:00:00`
                                        : null
                                }
                                onChange={(value) => {
                                    setFiltro({
                                        ...filtro,
                                        competencia_inicial_geracao_comparativo_com_sem_solar: value
                                            ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                            : null,
                                    });
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid cols="6 4 3 2">
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                            <DatePicker
                                variant="inline"
                                openTo="year"
                                views={["year", "month"]}
                                label="Até"
                                autoOk
                                value={
                                    filtro.competencia_final_geracao_comparativo_com_sem_solar
                                        ? `${String(filtro.competencia_final_geracao_comparativo_com_sem_solar).substring(0, 4)}/${String(filtro.competencia_final_geracao_comparativo_com_sem_solar).substring(4, 6)}/01 12:00:00`
                                        : null
                                }
                                onChange={(value) => {
                                    setFiltro({
                                        ...filtro,
                                        competencia_final_geracao_comparativo_com_sem_solar: value
                                            ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                            : null,
                                    });
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid cols="12 4 3 2" style={{ paddingTop: 10 }}>
                        <Button
                            text="Limpar Período"
                            type={"primary"}
                            icon={"fa fa-minus"}
                            event={() => {
                                setFiltro({
                                    ...filtro,
                                    competencia_inicial_geracao_comparativo_com_sem_solar: null,
                                    competencia_final_geracao_comparativo_com_sem_solar: null,
                                });
                            }}
                        />
                    </Grid>
                    <Grid cols="6 4 3 2" style={{ paddingTop: 10 }}>
                        <Button text="Analisar" type={"primary"} icon={"fa fa-sync"} event={getListaGraficoComparativoComSemSolarPeriodo} />
                    </Grid>
                </Row>
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                    <div style={{ minWidth: "890px" }}>
                        <Row>
                            <Grid cols="12 12 12 6" style={{ paddingTop: 10 }}>
                                <div id="graficoComparativoComSemSolarEnergiaPeriodo" style={{ width: "100%", height: "400px" }}></div>
                            </Grid>
                            <Grid cols="12 12 12 6" style={{ paddingTop: 10 }}>
                                <div id="graficoComparativoComSemSolarValorPeriodo" style={{ width: "100%", height: "400px" }}></div>
                            </Grid>
                        </Row>
                    </div>
                </ContentCardBody>
            </ContentCard>
            {exibirGraficosGeradora && (
                <>
                    <ContentCard style={{ color: "#fff", padding: 8 }}>
                        <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                            <div id="tituloGraficoGeracaoRetornoFinanceiro" style={{ color: "#fff", textAlign: "center" }}>
                                <div style={{ marginTop: 10, fontSize: 16 }}>Retorno Financeiro (%)</div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                                    <div style={{ backgroundColor: "#006d2e", width: 300, paddingTop: 8, paddingBottom: 8 }}>
                                        Retorno Total: {FormatUtils.formatarValorTela(retornoFinanceiro || 0, 2)}%
                                    </div>
                                </div>
                            </div>
                            <div id="graficoGeracaoRetornoFinanceiro" style={{ width: "100%", minWidth: "890px", height: 400, marginTop: -20 }}></div>
                        </ContentCardBody>
                    </ContentCard>

                    <ContentCard style={{ color: "#fff", padding: 8 }}>
                        <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "auto", textAlign: "center" }}>
                            <div id="tituloGraficoGeracaoAnaliseRetornoFinanceiroAnual" style={{ color: "#fff", textAlign: "center" }}>
                                <div style={{ marginTop: 10, fontSize: 16 }}>Análise do Retorno Financeiro (R$)</div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                                    <div style={{ backgroundColor: "#006d2e", width: 300, paddingTop: 8, paddingBottom: 8 }}>
                                        Retorno Total: {FormatUtils.formatarValorTela(retornoFinanceiro || 0, 2)}%
                                    </div>
                                </div>
                            </div>
                            <div id="graficoGeracaoAnaliseRetornoFinanceiroAnual" style={{ width: "100%", minWidth: "890px", height: 400, marginTop: -20 }}></div>
                        </ContentCardBody>
                    </ContentCard>
                </>
            )}
        </div>
    );

    function ExportAnalise({ listaGraficosDisponiveis }) {
        const [graficosAtivos, setGraficosAtivos] = useState(listaGraficosDisponiveis);

        const todosMarcados = graficosAtivos.length === listaGraficosDisponiveis.length;

        const existeAlgumMarcado = !!graficosAtivos.length;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) => setGraficosAtivos(todosMarcados ? [] : listaGraficosDisponiveis)}
                    value={todosMarcados}
                />
                {listaGraficosDisponiveis.includes("graficoGeracaoAvaliacaoProducaoMensal") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoAvaliacaoProducaoMensalCheckbox"
                        label="Geração Projetada X Realidade (kWh)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoAvaliacaoProducaoMensal")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoAvaliacaoProducaoMensal")
                                    : [...graficosAtivos, "graficoGeracaoAvaliacaoProducaoMensal"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoAvaliacaoProducaoMensal")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoAvaliacaoProducaoAnual") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoAvaliacaoProducaoAnualCheckbox"
                        label="Avaliação da Produção Total (kWh)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoAvaliacaoProducaoAnual")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoAvaliacaoProducaoAnual")
                                    : [...graficosAtivos, "graficoGeracaoAvaliacaoProducaoAnual"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoAvaliacaoProducaoAnual")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoQuantidadeAnual") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoQuantidadeAnualCheckbox"
                        label="Comportamento de Energia Excedente Anual (kWh)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoQuantidadeAnual")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoQuantidadeAnual")
                                    : [...graficosAtivos, "graficoGeracaoQuantidadeAnual"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoQuantidadeAnual")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoQuantidadeMensal") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoQuantidadeMensalCheckbox"
                        label="Comportamento de Energia Excedente Mensal (kWh)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoQuantidadeMensal")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoQuantidadeMensal")
                                    : [...graficosAtivos, "graficoGeracaoQuantidadeMensal"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoQuantidadeMensal")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoSaldo") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoSaldoCheckbox"
                        label="Saldo de Geração (kWh)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoSaldo")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoSaldo")
                                    : [...graficosAtivos, "graficoGeracaoSaldo"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoSaldo")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoComparativoConsumo") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoComparativoConsumoCheckbox"
                        label="Consumo (kWh): Antes X Depois"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoComparativoConsumo")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoComparativoConsumo")
                                    : [...graficosAtivos, "graficoGeracaoComparativoConsumo"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoComparativoConsumo")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoConsumoInstantaneo") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoConsumoInstantaneoCheckbox"
                        label="Simulação de Consumo Instantâneo (kWh)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoConsumoInstantaneo")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoConsumoInstantaneo")
                                    : [...graficosAtivos, "graficoGeracaoConsumoInstantaneo"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoConsumoInstantaneo")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoEconomiaTotal") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoEconomiaTotalCheckbox"
                        label="Economia Anual(R$)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoEconomiaTotal")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoEconomiaTotal")
                                    : [...graficosAtivos, "graficoGeracaoEconomiaTotal"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoEconomiaTotal")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoEconomia") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoEconomiaCheckbox"
                        label="Economia Mensal(R$)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoEconomia")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoEconomia")
                                    : [...graficosAtivos, "graficoGeracaoEconomia"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoEconomia")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoEconomiaPonta") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoEconomiaPontaCheckbox"
                        label="Economia Horário Ponta (R$)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoEconomiaPonta")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoEconomiaPonta")
                                    : [...graficosAtivos, "graficoGeracaoEconomiaPonta"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoEconomiaPonta")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoComparativoComSemSolarMensal") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoComparativoComSemSolarMensalCheckbox"
                        label="Comparativo (Com Solar X Sem Solar) Mensal"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoComparativoComSemSolarMensal")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoComparativoComSemSolarMensal")
                                    : [...graficosAtivos, "graficoComparativoComSemSolarMensal"]
                            )
                        }
                        value={graficosAtivos.includes("graficoComparativoComSemSolarMensal")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficosComparativosComSemSolarPeriodo") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficosComparativosComSemSolarPeriodoCheckbox"
                        label="Comparativo (Com Solar X Sem Solar) por Período"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficosComparativosComSemSolarPeriodo")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficosComparativosComSemSolarPeriodo")
                                    : [...graficosAtivos, "graficosComparativosComSemSolarPeriodo"]
                            )
                        }
                        value={graficosAtivos.includes("graficosComparativosComSemSolarPeriodo")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoRetornoFinanceiro") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoRetornoFinanceiroCheckbox"
                        label="Retorno Financeiro (%)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoRetornoFinanceiro")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoRetornoFinanceiro")
                                    : [...graficosAtivos, "graficoGeracaoRetornoFinanceiro"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoRetornoFinanceiro")}
                    />
                )}
                {listaGraficosDisponiveis.includes("graficoGeracaoAnaliseRetornoFinanceiroAnual") && (
                    <LabelAndCheckbox
                        style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                        id="graficoGeracaoAnaliseRetornoFinanceiroAnualCheckbox"
                        label="Análise do Retorno Financeiro (R$)"
                        onChange={(e) =>
                            setGraficosAtivos(
                                graficosAtivos.includes("graficoGeracaoAnaliseRetornoFinanceiroAnual")
                                    ? graficosAtivos.filter((grafico) => grafico !== "graficoGeracaoAnaliseRetornoFinanceiroAnual")
                                    : [...graficosAtivos, "graficoGeracaoAnaliseRetornoFinanceiroAnual"]
                            )
                        }
                        value={graficosAtivos.includes("graficoGeracaoAnaliseRetornoFinanceiroAnual")}
                    />
                )}
                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={(e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                handleExport({ graficosAtivos });
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => setModalExportacaoAberto(false)}
                        />
                    </Grid>
                </Row>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    filtro: state.analise.filtro,
    listaUnidadeConsumidora: state.analise.listaUnidadeConsumidora,
    contratoDemanda: state.analise.contratoDemanda,
    listaGraficoGeracaoQuantidadeAnual: state.analise.listaGraficoGeracaoQuantidadeAnual,
    listaGraficoGeracaoSaldo: state.analise.listaGraficoGeracaoSaldo,
    listaIndiceAntesDepois: state.analise.listaIndiceAntesDepois,
    listaGraficoGeracaoAvaliacaoProducaoAnual: state.analise.listaGraficoGeracaoAvaliacaoProducaoAnual,
    listaGraficoGeracaoComparativoConsumo: state.analise.listaGraficoGeracaoComparativoConsumo,
    listaGraficoGeracaoEconomia: state.analise.listaGraficoGeracaoEconomia,
    listaGraficoGeracaoEconomiaPonta: state.analise.listaGraficoGeracaoEconomiaPonta,
    listaGraficoGeracaoConsumoInstantaneo: state.analise.listaGraficoGeracaoConsumoInstantaneo,
    listaGeracaoContrato: state.analise.listaGeracaoContrato,
    listaGraficoComparativoComSemSolarMensal: state.analise.listaGraficoComparativoComSemSolarMensal,
    listaGraficoComparativoComSemSolarPeriodo: state.analise.listaGraficoComparativoComSemSolarPeriodo,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDemanda,
            getListaIndiceAntesDepois,
            getListaGraficoGeracaoAvaliacaoProducao,
            getListaGraficoGeracaoSaldo,
            getListaGraficoGeracaoQuantidadeAnual,
            getGeracaoCadastro,
            getListaGraficoGeracaoComparativoConsumo,
            getListaGraficoGeracaoEconomia,
            getListaGraficoGeracaoEconomiaPonta,
            getListaGraficoGeracaoConsumoInstantaneo,
            getListaGraficoComparativoComSemSolarMensal,
            getListaGraficoComparativoComSemSolarPeriodo,
            gerarRelatorio,
            setFiltro,
        },
        dispatch
    );
export const AnaliseMicroMiniGeracao = connect(mapStateToProps, mapDispatchToProps)(AnaliseMicroMiniGeracaoComponent);
